/**
 * Javascript source for ACS Time Critical geo-location
 * Geo-locate the user's IP address then replace conent on the 
 * page according to the user's country
 */
acsGeo = function($) {

	var getLocatedCountryCookieName = 'geoLocateCountry',
		getLocatedContentStorageKey = 'geoContent_1';

    var init = function() {
	    initialiseGeolocatedContent();
    };
    
    /*
     * looks up the user's IP and returns the region name
     * Stores in a cookie so we don't need to keep hitting the service (slow + rate limited)
     * Uses a callback because the ajax functions is async, so you can pass in an anonymous function
     */
    var geoLocate = function(callback) {
    	
    	var cookievalue = Cookies.get(getLocatedCountryCookieName);
  		if (cookievalue == null || cookievalue=='')  {
  			
  			//perform the lookup with the geolocate service.  			
  			$.getJSON(ajax_url, { action: 'geo_locate' }, function(response) {
  				//console.log('result of IP lookup: ', response);
  				if (typeof response.country != undefined) {
  					Cookies.set(getLocatedCountryCookieName, response.country, { expires: 30 }); 
        			callback(response.country); 					
  				} else {
				    //will get default content
					callback(''); 
				}
  			});
  			
      } else {
        //just return the value of the cookie
        callback(cookievalue);
      }
    };
    
    /*
     * Load in content that changes based on the user's location
     */
    var initialiseGeolocatedContent = function() {
	
	    //geolocate the user's IP
		geoLocate(function(country) {
			
			//before retrieving content via ajax we check if we already have it saved in local storage
			var content = store.get(getLocatedContentStorageKey),
				oneday  = 60 * 60 * 24 * 1000,
				expires = Date.now() - oneday;

			//if stored content is older than 24 hours OR for the wrong country, remove it and start again
			if (content && (content.country!=country || content.timestamp<expires)) {
				//console.log('geo content from local storage expired or wrong region');
				store.remove(getLocatedContentStorageKey);
				content = false;
			}
			
			if (content) {
				processGeolocatedContent(content);				
			} else {
				//we need to retrieve the content
				$.ajax({
		  		    url: ajax_url,//set in the footer
					dataType: "json",
					type: "GET",
					data: {
						action: 'geo_content',
						country: country
					}
				})
				.done(function( content ) {
					//console.log('retrieved geo content ok');
					
					//add the current timestamp to the result
					content.timestamp = Date.now();
					//console.log(content);
					
					//add data to localstorage via the cross-browser library
					store.set(getLocatedContentStorageKey, content);
					
					processGeolocatedContent(content);
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					console.log('Retrieving Geolocated Content failed.');
					console.log( jqXHR );
					console.log( textStatus );
				});
			}        
	    });
    };
    
    /*
     * Apply the content that changes based on the user's location
     */
    var processGeolocatedContent = function(content) {
    	
        var telLink = content.phone_number.replace(/\D/g,'');
	    $('.geo-phone-number').html('<a href="tel:'+telLink+'">'+content.phone_number+'</a>');
    };
    
    return{init:init}//return items that are available outside

}(jQuery);


//document ready
jQuery(function() {
	acsGeo.init();
});